// Messages for operator/quotes/QuoteFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.quote_form.mode.ship': 'Ocean',
  'operator.quote_form.mode.air': 'Air',
  'operator.quote_form.mode.truck': 'Truck',
  'operator.quote_form.mode.train': 'Rail',
  'operator.quote_form.title.edit': 'Edit quote',
  'operator.quote_form.title.new': 'New quote',
  'operator.quote_form.cancel': 'Cancel',
  'operator.quote_form.save_changes': 'Save changes',
  'operator.quote_form.create': 'Create quote',
  'operator.quote_form.title.convert': 'Convert request to quote',
  'operator.quote_form.convert': 'Convert to quote',
  'operator.quote_form.convert_banner': 'Converting request · {lane}',
  'operator.quote_form.create_from_lead': 'Create a new customer from this lead: {company}',
  'operator.quote_form.section.quote': 'Quote',
  'operator.quote_form.field.shipment': 'Shipment (optional)',
  'operator.quote_form.shipment_aria': 'Shipment',
  'operator.quote_form.shipment_placeholder': 'No shipment yet',
  'operator.quote_form.field.customer': 'Customer',
  'operator.quote_form.customer_aria': 'Customer',
  'operator.quote_form.customer_placeholder': 'Select a customer',
  'operator.quote_form.field.template': 'From template (optional)',
  'operator.quote_form.template_aria': 'From template',
  'operator.quote_form.template_none': 'None — enter charges below',
  'operator.quote_form.template_mode_any': 'Any',
  'operator.quote_form.template_summary': '{mode} · {count} line items',
  'operator.quote_form.field.mode': 'Mode',
  'operator.quote_form.mode_aria': 'Mode',
  'operator.quote_form.mode_placeholder': 'Select a mode',
  'operator.quote_form.field.carrier': 'Carrier',
  'operator.quote_form.carrier_aria': 'Carrier',
  'operator.quote_form.carrier_placeholder': 'Select a carrier',
  'operator.quote_form.field.container_size': 'Container size',
  'operator.quote_form.container_size_aria': 'Container size',
  'operator.quote_form.container_size_placeholder': 'FCL / LCL',
  'operator.quote_form.field.incoterm': 'Incoterm',
  'operator.quote_form.incoterm_aria': 'Incoterm',
  'operator.quote_form.incoterm_placeholder': 'Select an incoterm',
  'operator.quote_form.section.routing': 'Routing & validity',
  'operator.quote_form.field.loading_port': 'Loading port',
  'operator.quote_form.loading_port_aria': 'Loading port',
  'operator.quote_form.field.origin_location': 'Origin location',
  'operator.quote_form.origin_location_aria': 'Origin location',
  'operator.quote_form.field.discharge_port': 'Destination port',
  'operator.quote_form.discharge_port_aria': 'Destination port',
  'operator.quote_form.field.final_destination': 'Final destination',
  'operator.quote_form.final_destination_aria': 'Final destination',
  'operator.quote_form.location_placeholder': 'Search a port or location',
  'operator.quote_form.location_create': 'Create "{name}"',
  'operator.quote_form.field.transit_days': 'Transit days',
  'operator.quote_form.field.valid_until': 'Valid until',
  'operator.quote_form.valid_until_aria': 'Valid until',
  'operator.quote_form.field.currency': 'Currency',
  'operator.quote_form.currency_aria': 'Currency',
  'operator.quote_form.section.cargo': 'Cargo & remarks',
  'operator.quote_form.field.cargo_details': 'Cargo details',
  'operator.quote_form.cargo_details_aria': 'Cargo details',
  'operator.quote_form.cargo_details_placeholder': 'Commodity, packing, dimensions…',
  'operator.quote_form.field.remarks': 'Remarks',
  'operator.quote_form.remarks_aria': 'Remarks',
  'operator.quote_form.remarks_placeholder': 'Internal notes or conditions',
  'operator.quote_form.section.charges': 'Charges',
  'operator.quote_form.modify_sent.title': 'Modify a sent quote?',
  'operator.quote_form.modify_sent.message_sent':
    'This quote has already been sent to the customer. Are you sure you want to modify it?',
  'operator.quote_form.modify_sent.message_confirmed':
    'This quote has already been confirmed by the customer. Are you sure you want to modify the agreed pricing?',
  'operator.quote_form.modify_sent.confirm': 'Modify quote',
}

export const zhTW = {
  'operator.quote_form.mode.ship': '海運',
  'operator.quote_form.mode.air': '空運',
  'operator.quote_form.mode.truck': '卡車',
  'operator.quote_form.mode.train': '鐵路',
  'operator.quote_form.title.edit': '編輯報價',
  'operator.quote_form.title.new': '新報價',
  'operator.quote_form.cancel': '取消',
  'operator.quote_form.save_changes': '儲存變更',
  'operator.quote_form.create': '建立報價',
  'operator.quote_form.title.convert': '將需求轉為報價',
  'operator.quote_form.convert': '轉為報價',
  'operator.quote_form.convert_banner': '轉換需求 · {lane}',
  'operator.quote_form.create_from_lead': '從此潛在客戶建立新客戶：{company}',
  'operator.quote_form.section.quote': '報價',
  'operator.quote_form.field.shipment': '貨件（選填）',
  'operator.quote_form.shipment_aria': '貨件',
  'operator.quote_form.shipment_placeholder': '尚無貨件',
  'operator.quote_form.field.customer': '客戶',
  'operator.quote_form.customer_aria': '客戶',
  'operator.quote_form.customer_placeholder': '選擇客戶',
  'operator.quote_form.field.template': '從範本（選填）',
  'operator.quote_form.template_aria': '從範本',
  'operator.quote_form.template_none': '無 — 在下方輸入費用項目',
  'operator.quote_form.template_mode_any': '不限',
  'operator.quote_form.template_summary': '{mode} · {count} 個項目',
  'operator.quote_form.field.mode': '運輸方式',
  'operator.quote_form.mode_aria': '運輸方式',
  'operator.quote_form.mode_placeholder': '選擇運輸方式',
  'operator.quote_form.field.carrier': '承運商',
  'operator.quote_form.carrier_aria': '承運商',
  'operator.quote_form.carrier_placeholder': '選擇承運商',
  'operator.quote_form.field.container_size': '貨櫃類型',
  'operator.quote_form.container_size_aria': '貨櫃類型',
  'operator.quote_form.container_size_placeholder': 'FCL / LCL',
  'operator.quote_form.field.incoterm': '貿易條件',
  'operator.quote_form.incoterm_aria': '貿易條件',
  'operator.quote_form.incoterm_placeholder': '選擇貿易條件',
  'operator.quote_form.section.routing': '路線與有效期',
  'operator.quote_form.field.loading_port': '裝貨港',
  'operator.quote_form.loading_port_aria': '裝貨港',
  'operator.quote_form.field.origin_location': '起運地',
  'operator.quote_form.origin_location_aria': '起運地',
  'operator.quote_form.field.discharge_port': '目的港',
  'operator.quote_form.discharge_port_aria': '目的港',
  'operator.quote_form.field.final_destination': '最終目的地',
  'operator.quote_form.final_destination_aria': '最終目的地',
  'operator.quote_form.location_placeholder': '搜尋港口或地點',
  'operator.quote_form.location_create': '新增「{name}」',
  'operator.quote_form.field.transit_days': '運輸天數',
  'operator.quote_form.field.valid_until': '有效期至',
  'operator.quote_form.valid_until_aria': '有效期至',
  'operator.quote_form.field.currency': '貨幣',
  'operator.quote_form.currency_aria': '貨幣',
  'operator.quote_form.section.cargo': '貨物與備註',
  'operator.quote_form.field.cargo_details': '貨物明細',
  'operator.quote_form.cargo_details_aria': '貨物明細',
  'operator.quote_form.cargo_details_placeholder': '品名、包裝、尺寸…',
  'operator.quote_form.field.remarks': '備註',
  'operator.quote_form.remarks_aria': '備註',
  'operator.quote_form.remarks_placeholder': '內部備註或條件',
  'operator.quote_form.section.charges': '費用項目',
  'operator.quote_form.modify_sent.title': '修改已送出的報價？',
  'operator.quote_form.modify_sent.message_sent': '此報價已送出給客戶，確定要修改嗎？',
  'operator.quote_form.modify_sent.message_confirmed':
    '此報價已獲客戶確認，確定要修改雙方議定的價格嗎？',
  'operator.quote_form.modify_sent.confirm': '修改報價',
}
